import buildRoutes from 'ember-engines/routes';
export default buildRoutes(function () {
  this.route('artifacts', {
    path: '/'
  });
  this.route('artifact', function () {
    this.route('detail', {
      path: '/:slug/version/:version'
    });
  });
});